import { connect } from "react-redux";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import Pagination from "@material-ui/lab/Pagination";
// core componentssrc
import { useQuery } from "@tanstack/react-query";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import { ConditionGuard } from "guards/ConditionGuard";
import moment from "moment";
import { useFormContext } from "react-hook-form";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const ResultSection = ({
  handleOpenDialog,
  detailsEnabled = true,
  sortColumn,
  setSortColumn,
  sortDirection,
  setSortDirection,
  onPaginationChange,
  onResetToFirstPage,
}) => {
  const theme = useTheme();
  const classes = useStylesGeneric();

  const { watch, setValue } = useFormContext();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["listWorkCenters"],
    enabled: false,
    select: (response) => {
      if (!response?.data) return {};

      return {
        data: response.data.data,
        totalCount: response.data.totalCount,
        totalPages: response.data.totalPages,
      };
    },
  });

  const page = watch("pageIndex");

  const tableHead = [
    { label: "Data de Registo", sortKey: "created" },
    { label: "Nome do Centro", sortKey: "name" },
    { label: "Província", sortKey: "province" },
    { label: "Munícipio", sortKey: "municipality" },
    { label: "Actividade", sortKey: "secundaryActivity" },
    { label: "Data de actualização", sortKey: "lastModified" },
  ];

  const handleSort = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
    setValue("pageIndex", 1);
    onResetToFirstPage?.();
    
    setTimeout(() => {
      refetch();
    }, 0);
  };

  const renderSortIcon = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    if (sortColumn === column) {
      return sortDirection === "desc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      );
    }
    return <UnfoldMoreIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle", opacity: 0.3 }} />;
  };

  const handleOpenDetails = (workCenter) => {
    handleOpenDialog(workCenter);
  };

  return (
    <>
      <CardTableContainer title={"Lista de Centros de Trabalho Registados Na Sua Empresa"} count={data?.totalCount}>
        <TableContainer>
          <ConditionGuard condition={!isLoading} fallback={<TableBackdrop open />}>
            <Box component={Table} alignItems="center" marginBottom="0!important">
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                      }}
                      onClick={() => handleSort(key)}
                      style={{ cursor: "pointer", userSelect: "none" }}
                    >
                      <Box display="flex" alignItems="center">
                        {prop.label}
                        {renderSortIcon(key)}
                      </Box>
                    </TableCell>
                  ))}
                  <ConditionGuard condition={detailsEnabled}>
                    <TableCell
                      key="detailsCol"
                      classes={{
                        root:
                          classes.tableCellRoot +
                          " " +
                          classes.tableCellRootHead +
                          " " +
                          classes.tableCellHeadStickyRight,
                      }}
                    >
                      Detalhes
                    </TableCell>
                  </ConditionGuard>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.data?.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      {moment(prop.created).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.name}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.province}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.municipality}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.secundaryActivity}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      {prop.lastModified ? moment(prop.lastModified).format("DD-MM-YYYY") : "-"}
                    </TableCell>
                    <ConditionGuard condition={detailsEnabled}>
                      <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                        <Tooltip title="Detalhes">
                          <IconButton onClick={() => handleOpenDetails(prop.id)}>
                            <Box
                              component={ArrowForwardIosIcon}
                              width="12px!important"
                              height="12px!important"
                              color={theme.palette.primary.main}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </ConditionGuard>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
          </ConditionGuard>
        </TableContainer>

        <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end"></Box>

        <Pagination
          className={classes.alignPagination}
          count={data?.totalPages}
          page={page}
          onChange={(_, value) => {
            onPaginationChange?.(value);
          }}
          color="primary"
        />
      </CardTableContainer>

      {!isLoading && data?.data?.length === 0 && (
        <Box classes={{ root: classes.noResultsInfo }}>Não foram encontrados resultados para esta pesquisa.</Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(ResultSection);
